function MonitoringInterface() {
    /**
     * Logs the provided error and re-throws it.
     * Must be implemented by the monitoring tool.
     * @method logAndRethrow
     */
    this.logAndRethrow = function () {
        throw new Error("logAndRethrow() must be implemented by the monitoring tool");
    };

    /**
     * Captures a page action.
     * Must be implemented by the monitoring tool.
     * @method addPageAction
     */
    this.addPageAction = function () {
        throw new Error("addPageAction() must be implemented by the monitoring tool");
    };

    /**
     * Reports an error.
     * Must be implemented by the monitoring tool.
     * @method noticeError
     */
    this.noticeError = function () {
        throw new Error("noticeError() must be implemented by the monitoring tool");
    };

    /**
     * Sets a custom event attribute.
     * Must be implemented by the monitoring tool.
     * @method setCustomEventAttribute
     */
    this.setCustomEventAttribute = function () {
        throw new Error("setCustomEventAttribute() must be implemented by the monitoring tool");
    };

}

module.exports = MonitoringInterface;